import { render, staticRenderFns } from "./BrandableCard.vue?vue&type=template&id=54e183c8&scoped=true&"
import script from "./BrandableCard.vue?vue&type=script&lang=js&"
export * from "./BrandableCard.vue?vue&type=script&lang=js&"
import style0 from "./BrandableCard.vue?vue&type=style&index=0&id=54e183c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e183c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e183c8')) {
      api.createRecord('54e183c8', component.options)
    } else {
      api.reload('54e183c8', component.options)
    }
    module.hot.accept("./BrandableCard.vue?vue&type=template&id=54e183c8&scoped=true&", function () {
      api.rerender('54e183c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/CardContainers/BrandableCard.vue"
export default component.exports